import isEmpty from 'lodash/isEmpty'

import {
  getCategoryContentFromContentService,
  getContentFromContentService,
} from '@http/endpoints'

import {
  PAGE_NAMES_WITH_NO_PARAMS_SANITIZATION,
  PAGE_NAME_BY_PLP_SLUG,
  PAGE_NAME_BY_ROUTE_NAME,
  PAGE_TYPE_BY_ROUTE_NAME,
} from './content-service.config'

export const isSubPage = ({ routeName, pageCategory }) =>
  Object.keys(PAGE_TYPE_BY_ROUTE_NAME).includes(routeName) &&
  !isEmpty(pageCategory)

export const pageParamsFromRoute = ({ route }) => {
  const { pageName, pageCategory, slugV2 } = route.params
  const routeName = route.name
  const pageType = PAGE_TYPE_BY_ROUTE_NAME[routeName]

  return {
    pageType,
    pageName:
      pageName ||
      PAGE_NAME_BY_ROUTE_NAME[routeName] ||
      PAGE_NAME_BY_PLP_SLUG[slugV2],
    pageCategory,
  }
}

export const requestEndpointFromRoute = ({ route }) => {
  const routeName = route.name
  const { pageCategory } = route.params

  return isSubPage({ routeName, pageCategory })
    ? getCategoryContentFromContentService
    : getContentFromContentService
}

export const requestCMSPageConfigFromRoute = ({ route }) => ({
  request: requestEndpointFromRoute({ route }),
  pathParams: pageParamsFromRoute({ route }),
})

function ignoreRouteParamsSanitization({ parentPageInfos, route }) {
  return (
    isEmpty(parentPageInfos) ||
    PAGE_NAMES_WITH_NO_PARAMS_SANITIZATION.includes(route.name)
  )
}

export const sanitizeRouteParams = ({ parentPageInfos, route }) => {
  if (ignoreRouteParamsSanitization({ parentPageInfos, route })) return {}

  const routeParams = Object.keys(route.params)

  return Object.keys(parentPageInfos).reduce((updatedParams, info) => {
    if (
      routeParams.includes(info) &&
      route.params[info] !== parentPageInfos[info]
    ) {
      return {
        ...updatedParams,
        [info]: parentPageInfos[info],
      }
    }

    return updatedParams
  }, {})
}
